import dashboard from "./dashboard";
import publics from "./publics";
import news from "./news";
import stadium from "./stadium";
import gameMenus from "../vertical/gameMenu.js";
import report from "./report";
// import fnetpro from "./fnetpro.js";
export default [
  ...dashboard,
  ...gameMenus,
  ...news,
  ...stadium,
  ...report,
  ...publics,
];
